import { Link } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'
import { canSeeAdmin } from '../auth/adminAccess'
import { VerSportsLogo } from '@versports/ui'
import { ClubMark } from './ClubMark'

/**
 * Slim top bar. Rendered by `AppShell`. Shows the brand on the left and,
 * when authenticated, who's logged in + a logout button on the right. The
 * brand always links to `/` (home) — there's no in-app navigation here
 * because the home itself is the navigation hub.
 */
export function Topbar() {
  const { status, user, logout } = useAuth()
  const isAdmin = canSeeAdmin(user)
  // El separador y la marca dependen de que HAYA club, no de que su logo
  // cargue: sin logo `ClubMark` pinta las iniciales, nunca una imagen rota.
  const club = user?.branding_club ?? null

  return (
    <header className="topbar border-b-2 border-primary bg-surface shadow-[0_12px_36px_rgba(226,90,27,0.12)]">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-lg py-md">
        <Link to="/" className="flex items-center gap-md text-text-primary no-underline">
          <VerSportsLogo />
          {club && <span className="h-6 w-px bg-outline" aria-hidden="true" />}
          {club && <ClubMark logoUrl={club.logo_url} name={club.name} size={32} />}
        </Link>

        <div className="flex items-center gap-md text-sm">
          {isAdmin && (
            <Link to="/admin" className="tag-ok no-underline">
              admin
            </Link>
          )}
          {status === 'authenticated' && user && (
            <>
              <span className="text-text-muted">
                {user.profile?.display_name || user.username}
              </span>
              <button
                type="button"
                className="btn-ghost text-xs px-md py-xs"
                onClick={() => {
                  void logout()
                }}
              >
                Salir
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  )
}
